import React, { useContext } from 'react';
import defaultStyle from './index.module.scss';
import Modal from '../../atoms/modal';
import Close from '../../../assets/close.svg';
import { perfilSatContext } from '../../../context/perfil.sat.context';
import { useNavigate } from 'react-router-dom';


const ModalError: React.FC = () => {

  const browse = useNavigate();

  const {setOpenErrorModal} = useContext(perfilSatContext)

  return (
    <>
      <Modal isOpen={true} onClose={() => {}}>
        <div className={defaultStyle.container}>
          <div className={defaultStyle.containerTitle}>
            <div className={defaultStyle.errorTitle}>
              Ops, algo no salió como esperábamos
            </div>
            <img src={Close} alt={'Close'} style={{ cursor: 'pointer' }} onClick={() => setOpenErrorModal(false)} />
          </div>
          <div className={defaultStyle.border}></div>
          <div className={defaultStyle.errorMessage}>
            Descuida, puedes volver a intentarlo. Marcamos los <br />
            campos que debes corregir. Recuerda subir el archivo
            <br />
            correcto para cada sección.
          </div>
          <div className={defaultStyle.border}></div>
          <div className={defaultStyle.buttonsContainer}>
            <button className={defaultStyle.backButton} onClick={() => {browse('/login')}}>
              Volver al inicio
            </button>
            <button className={defaultStyle.button} onClick={() => setOpenErrorModal(false)}>
              Corregir campos
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalError;
